module.exports = __webpack_public_path__ + "static/oak_drugs-d7a5d2ed57d813507043baabdcae779c.png";